import { Observable } from 'rxjs/Observable';
import { Injectable } from "@angular/core";
import { Subject }    from 'rxjs/Subject';

@Injectable()
export class UtilService {
    hideChat = new Subject<any>();
    phoneNoChatDetails = new Subject<any>();
    userLogout = new Subject<any>();
    LogoutChatConfirm = new Subject<any>();
    hideHeaderNavDropDownNotSubscribed = new Subject<any>();
    callFollowUpAPI = new Subject<any>();
    callVcFollowUpAPI = new Subject<any>();
    callReferralPatientAPI = new Subject<any>();
    callParentRelapseAPI = new Subject<any>();
    callPatientRelapseAPI = new Subject<any>();
    callNonStartFollowupAPI = new Subject<any>();
    userProfilePicUpdated = new Subject<any>();
    defaultRoleChange = new Subject<any>();
    contractSignedPopup = new Subject<any>();
    userLoggedIn = new Subject<boolean>();

    // action required subjects
    showActionRequiredListOnRedirection = new Subject<any>();
    updateActionRequiredListPendingCount = new Subject<any>();
    actionRequiredListPendingCount = new Subject<any>();
    samePageUpdateByActionRequiredList = new Subject<any>();
    actionRequiredListPageUpdated = new Subject<any>();
    pageListUpdateFromActionRequiredList = new Subject<any>();

    sentPresentHHForm = new Subject<any>();
    reloadHHForms = new Subject<any>();
    setLatestHH = new Subject<any>();
    reloadPatientSurveys = new Subject<any>();

    setUserLoggedIn(userLoggedIn: boolean) {
        this.userLoggedIn.next(userLoggedIn);
    }

    getUserLoggedIn(): Observable<boolean> {
        return this.userLoggedIn.asObservable();
    }
}
